// extracted by mini-css-extract-plugin
export var card = "_md-1";
export var summary = "_md-0";